// // app/components/ui/Spinner.jsx
// export const Spinner = ({ className = "" }) => (
//   <svg className={`animate-spin ${className}`} viewBox="0 0 24 24" aria-hidden="true">
//     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
//     <path className="opacity-75" fill="currentColor" d="M4 12a 8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z" />
//   </svg>
// );

// // app/components/ui/Field.jsx
// export const Field = ({ label, children, hint }) => (
//   <label className="block">
//     <span className="text-[13px] font-semibold text-slate-800">{label}</span>
//     <div className="mt-1">{children}</div>
//     {hint ? <p className="mt-1 text-xs text-slate-500 select-none">{hint}</p> : null}
//   </label>
// );

// // app/components/ui/Select.jsx
// export const Select = ({ children, className = "", rightPad = "pr-10", ...props }) => (
//   <div className="relative group">
//     <select
//       {...props}
//       className={[
//         "w-full appearance-none",
//         "rounded-xl",
//         "px-3 py-2.5",
//         rightPad,
//         "text-sm md:text-base",
//         "bg-white/80 hover:bg-white",
//         "border border-slate-200/80",
//         "text-slate-800",
//         "shadow-sm backdrop-blur supports-[backdrop-filter]:bg-white/60",
//         "transition-all",
//         "outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-300/70",
//         "disabled:opacity-60 disabled:cursor-not-allowed",
//         className,
//       ].join(" ")}
//     >
//       {children}
//     </select>
//     <svg
//       className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-indigo-500/80 group-focus-within:text-indigo-600"
//       viewBox="0 0 20 20"
//       fill="currentColor"
//       aria-hidden
//     >
//       <path
//         fillRule="evenodd"
//         d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
//         clipRule="evenodd"
//       />
//     </svg>
//   </div>
// );


// app/components/ui/Spinner.jsx
"use client";
export default function Spinner({ className = "" }) {
  return (
    <svg className={`animate-spin ${className}`} viewBox="0 0 24 24" aria-hidden="true" role="img">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z" />
    </svg>
  );
}
